import { BaseTextField } from '#components'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('vuetify:before-create', ({ vuetifyOptions }) => {
    vuetifyOptions.aliases = {
      ...vuetifyOptions.aliases,

      // TextFields
      EmailTextField: BaseTextField,
    }

    vuetifyOptions.defaults = {
      ...vuetifyOptions.defaults,

      EmailTextField: {
        label: 'Email address',
        type: 'email',
        name: 'email',
      },
    }
  })
})
